/**
 * @fileoverview POST handler for the "/engagement/in_app_message_color_profiles/duplicate" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { engagementInAppMessageColorProfilesDuplicateCacheKeys } from "./constants";
import type { PostIamTemplateResult } from "@dashboardApi/apis/engagementInAppMessageColorProfilesId";

export const postEngagementInAppMessageColorProfilesDuplicate = reactQueryMutationAdapter(
  engagementInAppMessageColorProfilesDuplicateCacheKeys,
  (ids: string | string[]): Promise<PostIamTemplateResult> => {
    return fetch("/engagement/in_app_message_color_profiles/duplicate", "POST", {
      ids: typeof ids == "string" ? [ids] : ids,
    });
  }
);
